var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 12L7.60049 9.57159L8.45833 8.66094L9.91667 10.1787L13.125 6.85748L14 7.75028L9.91667 12ZM6.58824 4.48264L11.9412 1.28642H1.23529L6.58824 4.48264ZM6.58824 6.0004L1.23529 2.80418V9.0002H5.30147L6.53676 10.2858H1.23529C0.895588 10.2858 0.604779 10.1599 0.362868 9.908C0.120956 9.65611 0 9.35327 0 8.99948V1.28142C0 0.927637 0.120098 0.622776 0.360294 0.366841C0.60049 0.110905 0.892157 -0.0111104 1.23529 0.000793598H11.9412C12.2843 0.0126976 12.576 0.142808 12.8162 0.391125C13.0564 0.639323 13.1765 0.937755 13.1765 1.28642V5.00046L11.9412 6.26824V2.80418L6.58824 6.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkEmail);
export default __webpack_public_path__ + "static/media/mark_email.f299bc164f6ef81da96f803e991bd130.svg";
export { ForwardRef as ReactComponent };